import {
  Icon,
  DatePicker,
  Select,
  Table,
  CheckBoxGroup,
  RaytebForm,
  Button,
  TypeaheadText,
} from '../../share/Elements'
import useFetch from '../../_services/fetch'
import { RaytebRequests } from '../../_services'
import { useSelector } from 'react-redux'
import { ReducerType } from '../../storeManager/ReducerType'
import { LoginInterface } from '../../Interfaces/LoginInterface'
import {
  InsertDoctorTimeSheetModal,
  LoadingFit,
  PageHeader,
  RaytebModal,
  UpdateDoctorTimeSheetModal,
} from '../../share/Components'
import { useState, useEffect } from 'react'
import HelTag from 'react-helmet'

const Timesheet = () => {
  var items: { [id: string]: CheckBoxInterface } = {
    ['0']: { lable: 'شنبه' },
    ['1']: { lable: 'یکشنبه' },
    ['2']: { lable: 'دوشنبه' },
    ['3']: { lable: 'سه شنبه' },
    ['4']: { lable: 'چهارشنبه' },
    ['5']: { lable: 'پنج شنبه' },
    ['6']: { lable: 'جمعه' },
  }
  const center = useSelector<ReducerType, CenterViewModel>(
    (state) => state.reducerCenter
  )
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  )
  const [doctorServe, setDoctorServe] = useState<DoctorServeViewModel | null>(
    null
  )

  const getDoctorTimeSheets = useFetch<
    Array<DoctorTimeSheetViewModel>,
    DoctorTimeSheetInputModel
  >({
    request: RaytebRequests.DoctorTimeSheet_GetDoctorTimeSheets_Post({
      centerId: center.id,
      token: user.token,
    }),
    onSuccess(data) { },
  })
  const getDoctorTimeSheetById = useFetch<
    DoctorTimeSheetViewModel,
    { id: string }
  >({
    request: RaytebRequests.DoctorTimeSheet_GetDoctorTimeSheetById_Post({
      token: user.token,
    }),
    onSuccess(data) {
      setShowUpdateTicket(true)
    },
  })
  const getDoctorServes = useFetch<Array<DoctorServeViewModel>, unknown>({
    request: RaytebRequests.Doctor_GetDoctorServe_GET({
      centerId: center.id!,
      token: user.token,
    }),
  })
  const deleteDoctorTimeSheet = useFetch<unknown, { id: string }>({
    request: RaytebRequests.DoctorTimeSheet_DeleteById_Post({
      token: user.token,
    }),
    onSuccess(data) {
      getDoctorTimeSheets.reFetch({
        fromDate: getDoctorTimeSheets.payLoad?.fromDate ?? new Date(),
        toDate: getDoctorTimeSheets.payLoad?.toDate ?? new Date(),
        shift: getDoctorTimeSheets.payLoad?.shift ?? undefined,
        days: getDoctorTimeSheets.payLoad?.days ?? undefined,
      })
    },
  })

  const deleteRangeDoctorTimeSheet = useFetch<
    unknown,
    DoctorTimeSheetDeleteRangeInputModel
  >({
    request: RaytebRequests.DoctorTimeSheet_DeleteRange_Post({
      token: user.token,
    }),
    onSuccess(data) {
      getDoctorTimeSheets.reFetch({
        fromDate: getDoctorTimeSheets.payLoad?.fromDate ?? new Date(),
        toDate: getDoctorTimeSheets.payLoad?.toDate ?? new Date(),
        shift: getDoctorTimeSheets.payLoad?.shift ?? undefined,
        days: getDoctorTimeSheets.payLoad?.days ?? undefined,
      })
      setShowDeleteRange(false)
    },
  })

  const [showInsertTicket, setShowInsertTicket] = useState<boolean>(false)
  const [showUpdateTicket, setShowUpdateTicket] = useState<boolean>(false)
  const [showDeleteRange, setShowDeleteRange] = useState<boolean>(false)

  useEffect(() => {
    getDoctorServes.reFetch();
    getDoctorTimeSheets.reFetch({
      fromDate: getDoctorTimeSheets.payLoad?.fromDate ?? new Date(),
      toDate: getDoctorTimeSheets.payLoad?.toDate ?? new Date(),
      shift: getDoctorTimeSheets.payLoad?.shift ?? undefined,
      days: getDoctorTimeSheets.payLoad?.days ?? undefined,
    })
  }, [center])
  return (
    <>
      <HelTag>
        <title>مدیریت ساعت کاری</title>
      </HelTag>
      <PageHeader title='مدیریت ساعت کاری' />
      <Button
        className='mt-2 mb-5 flex !p-0  text-primary w-24 border-0 !bg-inherit'
        onClick={() => setShowInsertTicket(true)}
      >
        <Icon icon='rayteb-record' className='text-3xl w-10' />
        <span className='text-sm text-center mt-1'>جدید</span>
      </Button>

      <RaytebForm
        className='grid grid-cols-2 gap-x-10 gap-y-6 px-4 justify-items-center items-center relative
        md:w-[50%] md:mx-auto'
        checkIsRequired={true}
        onSubmit={(e) => {
          getDoctorTimeSheets.reFetch({
            fromDate: e.target['fromDate'].getAttribute('rayteb-value'),
            toDate: e.target['toDate'].getAttribute('rayteb-value'),
            days: e.target['days'].getAttribute('rayteb-value'),
            shift: e.target['shift'].value,
          })
        }}
      >
        <LoadingFit
          isLoading={
            getDoctorTimeSheets.isLoading ||
            deleteDoctorTimeSheet.isLoading ||
            getDoctorTimeSheetById.isLoading
          }
        />
        <DatePicker
          innerText={'از تاریخ'}
          isRequired={true}
          className='rounded-md w-full h-9'
          name='fromDate'
          id={'fromDate'}
          raytebValue={new Date().toUTCString()}
          value={new Date().toShamsi()}
          onChange={(e) => {
            const toDate = document.getElementById(
              'toDate'
            )! as HTMLInputElement

            if (toDate.value) document.getElementById('submitForm')?.click()
          }}
        ></DatePicker>
        <DatePicker
          innerText={'تا تاریخ'}
          raytebValue={new Date().toUTCString()}
          value={new Date().toShamsi()}
          isRequired={true}
          name='toDate'
          id='toDate'
          className='rounded-md w-full h-9'
          onChange={(e) => {
            document.getElementById('submitForm')?.click()
          }}
        ></DatePicker>

        <Select
          className='w-full'
          name='shift'
          onChange={(e) => {
            document.getElementById('submitForm')?.click()
          }}
        >
          <option value={''}>همه شیفت ها</option>
          <option value={1}>شیفت صبح</option>
          <option value={2}>شیفت ظهر</option>
          <option value={3}>شیفت شب</option>
        </Select>

        <CheckBoxGroup
          items={items}
          isRequired={false}
          lable='همه روز ها'
          name='days'
          onChange={() => {
            const toDate = document.getElementById(
              'toDate'
            )! as HTMLInputElement
            const fromDate = document.getElementById(
              'fromDate'
            )! as HTMLInputElement
            if (toDate.value && fromDate.value)
              document.getElementById('submitForm')?.click()
          }}
        />

        <input id='submitForm' type='submit' value={''} className='hidden' />
      </RaytebForm>

      <div className='flex justify-between items-center mt-10 px-4 md:w-[80%] md:mx-auto'>
        <div className='flex justify-start items-center gap-2  '>
          <Icon
            icon='rayteb-history-track'
            className='text-3xl text-disable font-normal'
          />
          <span className='font-normal'>نمایش ساعت کاری</span>
        </div>
        <Button
          onClick={() => setShowDeleteRange(true)}
          className='!bg-danger border-dangerDark ring-1 ring-dangerLight 
        h-7 text-xs  text-white shadow-inner shadow-dangerDark'
        >
          حذف یکجا
        </Button>
      </div>

      <br />

      <div className='w-full px-2 md:w-[80%] md:mx-auto'>
        <Table>
          <thead className='text-xs bg-primaryLight text-white h-8'>
            <tr>
              <th
                scope='col'
                className='pr-2 text-center font-normal rounded-tr-2xl'
              >
                روز
              </th>
              <th scope='col' className='pt-1 p-0 text-center font-normal'>
                تاریخ
              </th>
              <th scope='col' className='pt-1 text-center font-normal'>
                شیفت
              </th>
              <th scope='col' className='pt-1  text-center font-normal'>
                زمان حضور
              </th>
              <th
                scope='col'
                className='pt-1 pl-2 text-center font-normal rounded-tl-2xl'
              >
                عملیات
              </th>
            </tr>
          </thead>
          <tbody className='text-xs font-bold'>
            {getDoctorTimeSheets.result?.map((n, i) => (
              <tr className='[&>*]:h-10' key={i}>
                <td className='pr-2 text-center'>{n.day}</td>
                <td className='text-center'>
                  {new Date(n.visitDate).toShamsi()}
                </td>
                <td className='text-center'>{n.shift}</td>
                <td className='text-center'>{n.visitTime.toPersian()}</td>
                <td className='pl-2 text-center flex justify-center  gap-2 items-center'>
                  <Icon
                    icon='rayteb-edit'
                    className='text-xl text-warn '
                    onClick={() => {
                      getDoctorTimeSheetById.reFetch({
                        id: n.id,
                      })
                    }}
                  />
                  <Icon
                    icon='rayteb-delete'
                    className='text-xl text-danger'
                    onClick={() => {
                      deleteDoctorTimeSheet.reFetch({ id: n.id })
                    }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      <InsertDoctorTimeSheetModal
        options={{
          className: ' relative',
          isOpen: showInsertTicket,
          title: 'ساعت کاری',
          hideModal: () => setShowInsertTicket(false),
        }}
        onSuccess={() => {
          getDoctorTimeSheets.reFetch({
            fromDate: getDoctorTimeSheets.payLoad?.fromDate ?? new Date(),
            toDate: getDoctorTimeSheets.payLoad?.toDate ?? new Date(),
            shift: getDoctorTimeSheets.payLoad?.shift ?? undefined,
            days: getDoctorTimeSheets.payLoad?.days ?? undefined,
          })
        }}
      />
      <UpdateDoctorTimeSheetModal
        options={{
          className: 'relative',
          isOpen: showUpdateTicket,
          title: 'ساعت کاری',
          hideModal: () => setShowUpdateTicket(false),
        }}
        onSuccess={() => {
          getDoctorTimeSheets.reFetch({
            fromDate: getDoctorTimeSheets.payLoad?.fromDate ?? new Date(),
            toDate: getDoctorTimeSheets.payLoad?.toDate ?? new Date(),
            shift: getDoctorTimeSheets.payLoad?.shift ?? undefined,
            days: getDoctorTimeSheets.payLoad?.days ?? undefined,
          })
        }}
        model={getDoctorTimeSheetById.result!}
      />
      <RaytebModal
        isOpen={showDeleteRange}
        title='حذف یکجا ساعت کاری'
        hideModal={() => setShowDeleteRange(false)}
      >
        <RaytebForm
          className='p-3 relative'
          checkIsRequired={true}
          onSubmit={(e) => {
            deleteRangeDoctorTimeSheet.reFetch({
              doctorServeId: doctorServe?.id!,
              fromDate: e.target['fromDate'].getAttribute('rayteb-value'),
              toDate: e.target['toDate'].getAttribute('rayteb-value'),
              shift: e.target['shift'].value,
            })
          }}
        >
          <LoadingFit
            isLoading={deleteRangeDoctorTimeSheet.isLoading}
            className='pb-3'
          />
          <div className='grid grid-cols-2 gap-3'>
            <TypeaheadText<DoctorServeViewModel>
              innerText='خدمت'
              fieldItem='title'
              fieldValue='id'
              selected={(e) => setDoctorServe(e)}
              listData={getDoctorServes.result}
              isRequired={true}
            ></TypeaheadText>
            <Select
              msgValidate='شیفت نمیتواند خالی باشد'
              className='w-full'
              name='shift'
              isRequired={true}
            >
              <option value={''}>انتخاب شیفت</option>
              <option value={1}>شیفت صبح</option>
              <option value={2}>شیفت ظهر</option>
              <option value={3}>شیفت شب</option>
            </Select>
            <DatePicker
              isRequired={true}
              name='fromDate'
              innerText='تاریخ شروع'
              className='w-full'
            />
            <DatePicker
              isRequired={true}
              name='toDate'
              innerText='تاریخ پایان'
              className='w-full'
            />
          </div>
          <div className='mt-7 flex justify-center items-center px-6 pb-3 gap-10 w-full'>
            <Button
              type='button'
              onClick={() => {
                setShowDeleteRange(false)
              }}
              className='!border-2 border-dangerLight !bg-danger !text-white
             !text-xs !w-full h-9 !shadow-lg'
            >
              انصراف
            </Button>
            <Button
              type='submit'
              className='!border-2 border-secondaryLight !bg-secondary !text-white
             !text-xs !w-full h-9 !shadow-lg'
            >
              تایید
            </Button>
          </div>
        </RaytebForm>
      </RaytebModal>
    </>
  )
}

export default Timesheet
